{
  "branding": {
    "frontdesk-attribution": "Омогућава FrontDesk+",
    "practice-logo": "Лого ординације {{name}}"
  },
  "validation": {
    "required": "Ово поље је обавезно",
    "invalid-url": "Молимо унесите важећу URL адресу",
    "pin-too-short": "PIN мора имати најмање 4 знака",
    "pin-default-rejected": "Стандардни ПИН 0000 није дозвољен. Доделите свој ПИН.",
    "invalid-kim-address": "Please enter a valid KIM address (e.g. praxis@musterpraxis.kim.telematik)."
  },
  "common": {
    "back": "Назад",
    "next": "Следеће",
    "cancel": "Откажи",
    "confirm": "Потврди",
    "done": "Готово",
    "retry": "Покушај поново",
    "clear": "Обриши",
    "close": "Затвори",
    "verifying": "Провера...",
    "select": "Одабери",
    "minutes": "минута",
    "clock": "",
    "gender": {
      "M": "Мушки",
      "W": "Женски",
      "D": "Разноврстан",
      "U": "Непознато"
    },
    "insurance": {
      "GKV": "Законско",
      "PKV": "Приватно",
      "SELFPAY": "Самоплаћање"
    },
    "scroll-up": "Помери нагоре",
    "scroll-down": "Помери надоле"
  },
  "settings": {
    "device-reset": {
      "title": "Ресетуј уређај",
      "description": "Обриши везу са ординацијом, подешавања и ПИН овог уређаја.",
      "confirmation": "Овај уређај треба поново подесити. Конфигурација SOL-а и подаци пацијената у inSuite-у остају непромењени.",
      "cancel": "Откажи",
      "confirm": "Ресетуј сада"
    },
    "title": "Подешавања",
    "save": "Сачувај",
    "save-success": "Подешавања сачувана",
    "save-error": "Грешка при чувању подешавања",
    "load-error": "Грешка при учитавању подешавања",
    "pin": {
      "title": "Потребан PIN",
      "description": "Молимо унесите свој PIN за приступ подешавањима.",
      "error": "Погрешан PIN. Молимо покушајте поново.",
      "backspace": "Обриши последњу цифру"
    },
    "connection": {
      "title": "Веза",
      "description": "Подешавања везе за Doc-Cirrus Bridge сервер",
      "bridge-url": "Bridge URL",
      "device-name": "Име уређаја",
      "device-name-placeholder": "нпр. Рецепција, соба 1, киоск",
      "device-name-hint": "Име за идентификацију на контролној табли Bridge",
      "kim-address": "KIM Адреса (опционо)",
      "kim-address-placeholder": "praxis@musterpraxis.kim.telematik",
      "kim-address-hint": "This device only. Leave empty to use the practice KIM address.",
      "test": "Тест",
      "success": "Веза успешна",
      "error": "Веза неуспешна",
      "api-unreachable": "DocCirrus АПИ недоступан",
      "status-title": "Статус везе",
      "status": {
        "api": "АПИ повезан",
        "ti": "Телематска инфраструктура",
        "card-reader": "Доступан читач картица",
        "medical-card": "Картица ординације (SMC-B/HBA)"
      },
      "kim-address-consequence": "At Online Check-in the insurer sends the insured person’s data to this address instead of the practice address.",
      "kim-address-practice": "Practice address",
      "kim-address-confirm-title": "Change the KIM address for this device?",
      "kim-address-confirm-description": "At Online Check-in the insurer will send the insured person’s data to this address from now on.",
      "kim-address-confirm-previous": "Current",
      "kim-address-confirm-next": "New",
      "kim-address-confirm-cancel": "Cancel",
      "kim-address-confirm-accept": "Change address",
      "sol-token": "Sol токен (из inSuite)",
      "sol-token-hint": "Копирајте га из управљања Bridge-ом у inSuite. Потребан је за везу.",
      "sol-token-show": "Прикажи токен",
      "sol-token-hide": "Сакриј токен",
      "bridge-unreachable": "Bridge није доступан. Проверите адресу и порт.",
      "diagnostic-id": "ИД дијагностике: {{id}}",
      "scan-qr": "Скенирај QR код",
      "scan-title": "Скенирај QR код Bridge-а",
      "scan-manual": "Унеси ручно"
    },
    "terminal": {
      "title": "Читач картица",
      "description": "Избор читача картица за телематичку инфраструктуру",
      "select": "Одабери терминал",
      "select-placeholder": "Изаберите терминал...",
      "loading": "Учитавање терминала...",
      "none-available": "Нема доступних терминала",
      "none-found": "Нема пронађених терминала",
      "found": "Пронађено {{count}} терминал(а)",
      "connect-hint": "Прво се повежите са bridge сервером за учитавање терминала.",
      "found-count": "Пронађени читачи картица: {{count}}",
      "refresh": "Поново учитај читаче картица"
    },
    "practice": {
      "title": "Ординација",
      "description": "Информације о вашој ординацији",
      "name": "Назив ординације",
      "name-placeholder": "нпр. Др Јовановић",
      "welcome-message": "Порука добродошлице",
      "welcome-placeholder": "нпр. Добро дошли у нашу ординацију",
      "scheduler-available": "Омогући Планер",
      "scheduler-available-description": "Дозволите пацијентима да резервишу прегледе преко терминала за самопослуживање",
      "prescription-available": "Омогућите услугу издавања на рецепт",
      "prescription-available-description": "Patients can request repeat prescriptions at the self-service terminal. The practice reviews every request.",
      "welcome-hint": "Оставите празно да би поздрав био на језику пацијента. Ваш сопствени текст приказује се непромењен на свим језицима."
    },
    "patient-info": {
      "eyebrow": "Patient information review",
      "description": "Applies practice-wide to every FrontDesk+ terminal and is enforced by the server.",
      "enabled": "Show the review after reading the health card",
      "phone": "Review telephone numbers",
      "email": "Review email addresses",
      "hausarzt": "Review primary physician",
      "selection-required": "Select at least one item to review.",
      "save": "Save review setting",
      "saved": "Review settings saved.",
      "conflict": "The setting changed in the meantime. The current version has been loaded.",
      "save-error": "The review settings could not be saved.",
      "unavailable": "The practice-wide setting is currently unavailable.",
      "scope": "Practice-wide · Server",
      "scope-description": "Stored on the practice server and enforced for all terminals.",
      "sentence-off": "The review is switched off. Patients are not asked about their contact details at the terminal.",
      "last-saved": "Last saved on the server: {{value}}",
      "never-saved": "Never saved on the server.",
      "last-saved-all": "Сачувано за све уређаје {{value}}",
      "never-saved-default": "Подразумевано подешавање, још није мењано."
    },
    "anamnesis": {
      "title": "Дигитална медицинска историја",
      "description": "Приказује везу и QR code до вашег лекара за историју болести након пријаве.",
      "enabled": "Прикажи везу за историју болести након пријаве",
      "enabled-description": "Приказује везу и QR code до вашег провајдера историје болести након завршеног чекирања, на пример Nelly.",
      "url": "Веза са добављачем историје болести",
      "url-hint": "Веза је статична и идентична за све пацијенте.",
      "preview-label": "Преглед екрана завршетка",
      "preview-note": "Веза је статична и идентична за све пацијенте.",
      "url-first": "За укључивање најпре унесите важећи линк."
    },
    "appearance": {
      "title": "Изглед",
      "description": "Прилагодите кориснички интерфејс",
      "language": "Језик",
      "default-kiosk-language": "Подразумевани језик пацијента",
      "default-kiosk-language-hint": "Језик на коме почињу нове сесије киоска за пацијенте.",
      "voice-over-volume": "Јачина звука преко гласа",
      "voice-over-hint": "Контролише јачину звука асистента за слушање гласа ради приступачности.",
      "language-first": "Прикажи избор језика на почетку сесије"
    },
    "security": {
      "title": "Безбедност",
      "description": "PIN за приступ подешавањима",
      "pin": "PIN",
      "pin-hint": "4-8 digits. At least 4 digits, and not 0000."
    },
    "eyebrow": "Управљање киоском",
    "nav": {
      "general": "Опште",
      "flows": "Функције",
      "anamnese": "Дигитална анамнеза",
      "device": "Уређај и веза"
    },
    "flows": {
      "title": "Функције на терминалу"
    },
    "language": {
      "title": "Језик и читање наглас",
      "description": "Језик и читање наглас за пацијенте на овом уређају."
    }
  },
  "self-service": {
    "title": "Самоуслуга",
    "step-progress": "Корак {{current}} / {{total}}",
    "flows": {
      "checkin": "Пријава",
      "scheduler": "Закажи термин",
      "prescription": "Рецепти",
      "locations": "Мапа локације",
      "emergency": "Хитност"
    },
    "audio-guide": {
      "on": "Звук укључен",
      "off": "Звук искључен",
      "replay": "Понови упутство",
      "replay-unavailable": "Нема гласовног упутства за понављање"
    },
    "language-selector": {
      "title": "Изаберите језик",
      "description": "Молимо изаберите жељени језик"
    },
    "settings": "Подешавања",
    "start": {
      "welcome": "Добродошли",
      "subtitle": "Молимо изаберите опцију",
      "check-in-label": "Главни пут",
      "check-in-cta": "Пријава",
      "check-in-description": "Већ имате термин? Пријавите се овде.",
      "check-in-hint": "Припремите своју картицу",
      "scheduler-label": "Ново",
      "scheduler-cta": "Закажи термин",
      "scheduler-description": "Закажите нови термин.",
      "location-plan": "Мапа локације",
      "location-plan-description": "Пронађите пут до собе за третман.",
      "prescription-label": "Рецепт",
      "prescription-cta": "Рецепти и наручивање",
      "prescription-description": "Прегледајте рецепте или наручите допуне.",
      "emergency-cta": "Локални аларм за хитне случајеве",
      "emergency-description": "Чује се само на овом уређају и не позива помоћ.",
      "tap-to-start": "Додирните за почетак"
    },
    "offline": {
      "banner-title": "Пријава је привремено недоступна",
      "banner-message": "Молимо разговарајте са особљем рецепције за помоћ.",
      "emergency-available": "Локални аларм остаје доступан. Не позива помоћ.",
      "flow-disabled": "Привремено недоступан"
    },
    "readability": {
      "toggle-label": "Режим читања",
      "on": "Режим читања",
      "off": "Режим читања"
    },
    "reset-overlay": {
      "timeout-title": "Седница је завршена",
      "timeout-subtitle": "Ваше време је истекло. Ваши подаци су безбедни.",
      "offline-title": "Веза је изгубљена",
      "offline-subtitle": "Веза је прекинута. Молимо разговарајте са особљем рецепције.",
      "interruption-title": "Седница је завршена",
      "interruption-subtitle": "Ваша сесија је безбедно завршена.",
      "completion-title": "Хвала!",
      "completion-subtitle": "Ваш захтев је успешно завршен.",
      "reassurance": "Ваши лични подаци се не чувају на овом уређају.",
      "auto-dismiss": "Враћање на почетак за {{seconds}} секунди...",
      "dismiss": "Идите на почетак"
    },
    "timed-terminal": {
      "countdown": "Аутоматски повратак за {{seconds}} секунди",
      "countdown-outcome": "Овај терминал ће се аутоматски вратити на почетни екран.",
      "more-time": "Више времена",
      "extended": "Време продужено"
    },
    "scheduler": {
      "questionnaire": {
        "language-unavailable": "Ова питања нису доступна на вашем језику. Изаберите један од понуђених језика или се обратите рецепцији.",
        "alternatives": "Алтернативни термини",
        "loading": "Учитавање питања…",
        "reception-fallback": "Молимо обратите се пријему.",
        "error-title": "Питања није било могуће учитати",
        "language-unavailable-lead": "Ова питања нису доступна на вашем језику.",
        "language-unavailable-title": "Молимо изаберите један од ових језика",
        "language-unavailable-body": "Или затражите помоћ на пријему."
      },
      "start": {
        "title": "Закажи термин",
        "subtitle": "Закажите жељени термин у неколико корака",
        "welcome": "Добродошли у заказивање термина",
        "description": "Водићемо вас кроз процес заказивања",
        "cta": "Закажи термин сада"
      },
      "patient-id": {
        "title": "Идентификација",
        "subtitle": "Молимо идентификујте се",
        "mode-card": "Са картицом",
        "mode-search": "Претрага",
        "mode-create": "Направи ново",
        "insert-card": "Молимо уметните своју здравствену картицу",
        "reading-card": "Читање картице...",
        "simulate-card": "Симулирај картицу",
        "multiple-matches": "Пронађено више пацијената. Користе се подаци са картице.",
        "search-placeholder": "Име или број осигурања...",
        "searching": "Претрага...",
        "no-results": "Нема пронађених резултата",
        "first-name": "Име",
        "last-name": "Презиме",
        "dob": "Датум рођења",
        "insurance": "Осигурање",
        "continue": "Настави",
        "creating": "Креирање пацијента...",
        "patient-created": "Пацијент је успешно креиран!",
        "create-error": "Није могуће креирати пацијента."
      },
      "appointment-type": {
        "title": "Изаберите врсту термина",
        "subtitle": "Молимо изаберите разлог посете",
        "loading": "Учитавање врста термина...",
        "no-types": "Нема доступних врста термина",
        "error": "Није могуће учитати врсте термина. Молимо покушајте поново.",
        "no-bookable": "Ове врсте термина тренутно није могуће заказати на киоску. Обратите се рецепцији или закажите телефоном.",
        "disabled-default": "Молимо закажите овај термин директно на рецепцији или телефоном.",
        "disabled-footer": "Само рецепција/телефон",
        "lead": "Коју врсту термина желите да резервишете?",
        "duration": "око {{minutes}} минута",
        "empty-title": "Овде тренутно није могуће резервисати термине",
        "none-bookable-title": "Ове термине овде не можете да резервишете",
        "none-bookable-body": "Молимо питајте на пријему или нас позовите."
      },
      "types": {
        "general": "Општи преглед",
        "general-desc": "За опште тегобе и питања",
        "checkup": "Превентивни преглед",
        "checkup-desc": "Редовни здравствени прегледи",
        "vaccination": "Вакцинација",
        "vaccination-desc": "Закажите вакцинацију",
        "followup": "Контрола",
        "followup-desc": "Контролни термин",
        "prescription": "Рецепт",
        "prescription-desc": "Преузимање рецепта"
      },
      "slot-selection": {
        "title": "Изаберите термин",
        "subtitle": "Молимо изаберите доступан термин",
        "loading": "Учитавање доступних термина...",
        "no-slots": "Нема доступних термина",
        "no-appointment-type": "Није изабрана врста термина",
        "error": "Није могуће учитати доступне термине. Молимо покушајте поново.",
        "quick-select": "Следећи доступни термини:",
        "select-date": "Или изаберите датум:",
        "times-for": "{{date}}",
        "available": "Доступно",
        "unavailable": "Нема термина",
        "slots": "термини",
        "select-time-hint": "Додирните време за заказивање термина",
        "week-short": "Нед",
        "weekday-mon": "Пон",
        "weekday-tue": "Уто",
        "weekday-wed": "Сре",
        "weekday-thu": "Чет",
        "weekday-fri": "Пет",
        "weekday-sat": "Суб",
        "weekday-sun": "Нед",
        "period-morning": "Јутро",
        "period-midday": "Подне",
        "period-afternoon": "Поподне",
        "period-evening": "Вече",
        "period-morning-short": "Јутро",
        "period-midday-short": "Подне",
        "period-afternoon-short": "Поп.",
        "period-evening-short": "Вече",
        "period-dots-legend": "Доступност времена",
        "filter-hint": "Филтрирај по жељеним временима:",
        "or-choose-below": "или изаберите испод",
        "no-slots-period": "Нема слотова",
        "show-all": "Прикажи све",
        "free": "бесплатно",
        "your-selection": "Ваш избор",
        "oclock": "сат",
        "choose-slot": "Изаберите слот",
        "choose-day": "Изаберите дан",
        "choose-day-first": "Молимо прво изаберите дан",
        "times-heading": "Слободна времена {{date}}",
        "time-value": "{{time}}",
        "empty-title": "Нема слободних термина: {{month}}",
        "empty-body": "Погледајте следећи месец или питајте на пријему – радо ћемо помоћи.",
        "next-month": "Следећи месец",
        "previous-month": "Претходни месец"
      },
      "confirmation": {
        "patient-responses": "Ваши одговори",
        "review-loading": "Провера сажетка…",
        "review-unavailable": "Резиме није доступан. Молимо покушајте поново или питајте на пријему.",
        "check-booking": "Проверите резервацију",
        "title": "Потврди термин",
        "subtitle": "Молимо прегледајте своју резервацију",
        "patient": "Пацијент",
        "datetime": "Датум и време",
        "booking": "Заказивање...",
        "confirm": "Закажи термин",
        "heading": "Да ли ово изгледа исправно?",
        "lead": "Молимо потврдите свој термин.",
        "appointment": "Именовање",
        "insured-via": "Осигурано преко",
        "description-label": "Напомене за ординацију (опционо)",
        "description-hint": "Реците нам ако нешто треба да узмемо у обзир при заказивању или пријави.",
        "description-placeholder": "нпр. ограничена покретљивост, пратилац, важне напомене",
        "description-too-long": "Молимо скратите напомену на највише 500 знакова.",
        "summary": "Резиме",
        "change": "Промена",
        "book-binding": "Заказивање термина",
        "cancel": "Откажите",
        "type-label": "Врста термина",
        "datetime-value": "{{date}} у {{time}}",
        "name-label": "Име",
        "insurance-label": "Осигурање",
        "insurance-GKV": "Законско здравствено осигурање",
        "insurance-PKV": "Приватно здравствено осигурање",
        "insurance-SELFPAY": "Самоплатилац",
        "change-time": "Промени термин",
        "description-free-text": "Остале напомене (необавезно)",
        "note-wheelchair": "Користим инвалидска колица",
        "note-companion": "Долазим у пратњи",
        "note-interpreter": "Треба ми преводилац"
      },
      "done": {
        "title": "Термин заказан!",
        "label": "Резервисано",
        "subtitle": "Ваш термин је успешно заказан.",
        "date": "Датум",
        "time": "Време",
        "booking-id": "Број резервације",
        "qr-hint": "Додај у календар",
        "qr-description": "Скенирајте овај QR код камером свог паметног телефона да бисте додали термин у своју апликацију календара",
        "auto-redirect": "Ускоро ћете бити преусмерени на почетну страницу...",
        "auto-redirect-countdown": "Повратак на почетак за {{seconds}} секунди...",
        "back-to-start": "Назад на почетак",
        "print-button": "Одштампајте потврду термина",
        "print-preparing": "Припрема приказа за штампу…",
        "print-error": "Потврду термина није могуће отворити. Покушајте поново или затражите помоћ на рецепцији.",
        "print-returned": "Системски приказ за штампу је затворен. По потреби можете затражити још један примерак.",
        "print-title": "Ваш термин",
        "print-location": "Локација",
        "print-map-hint": "Отворите локацију на телефону",
        "print-error-v2": "Потврду термина није било могуће отворити. Молимо покушајте поново или питајте на пријему."
      },
      "error": {
        "assistance-info": "Нисмо могли да потврдимо вашу резервацију. Термин је можда већ резервисан. Молимо питајте на пријему.",
        "pending-title": "Резервација није потврђена",
        "pending-info": "Нисмо могли да потврдимо вашу резервацију. Термин је можда већ резервисан. Молимо проверите поново или питајте на пријему.",
        "title": "Заказивање неуспешно",
        "subtitle": "Термин није могао бити заказан.",
        "info": "Молимо покушајте поново или питајте на пријему."
      },
      "phase": {
        "identify": "Пријава",
        "choose": "Избор термина",
        "confirm": "Потврда"
      }
    },
    "prescription": {
      "start": {
        "title": "Рецепти и наручивање",
        "subtitle": "Уметните своју картицу осигурања да бисте видели рецепте или наручили допуне.",
        "button": "Убаците картицу"
      },
      "card-check": {
        "loading": "Учитавање читача картица...",
        "no-terminal": "Није конфигурисан читач картица",
        "no-terminal-hint": "Молимо контактирајте особље за помоћ.",
        "insert-card": "Молимо убаците своју картицу",
        "insert-card-hint": "Убаците своју картицу осигурања у читач картица.",
        "card-detected": "Картица је откривена",
        "reading": "Картица за читање...",
        "reading-hint": "Молимо сачекајте тренутак.",
        "error": "Грешка при читању картице",
        "retry": "Покушајте поново",
        "manual-lookup": "Наставите без картице",
        "load-error": "Није могуће учитати читач картица",
        "read-error": "Картица није могла да се прочита"
      },
      "patient-selection": {
        "title": "Изаберите Пацијент",
        "subtitle": "Пронађено је више пацијената. Молимо изаберите своје име.",
        "try-again": "Покушајте поново",
        "try-again-hint": "Поново убаците картицу"
      },
      "list": {
        "title": "Ваши рецепти",
        "for-patient": "Рецепти за {{name}}",
        "loading": "Учитавање рецепата...",
        "error-title": "Грешка при учитавању",
        "fetch-error": "Рецепти се не могу учитати",
        "back-home": "Назад на почетак",
        "done": "Урађено"
      },
      "detail": {
        "prescription-info": "Информације о рецепту",
        "date": "Датум",
        "prescriber": "Прописивач",
        "comment": "Напомена",
        "medications": "Лекови",
        "form": "Образац",
        "pack-size": "Величина паковања",
        "manufacturer": "Произвођач",
        "loading": "Учитавање рецепта...",
        "fetch-error": "Детаљи о рецепту нису могли да се учитају",
        "back-to-list": "Повратак на листу",
        "print": "Штампај"
      },
      "types": {
        "public": "Јавни рецепт",
        "private": "Приватни рецепт",
        "long-term": "Дугорочни рецепт",
        "btm": "Рецепт за наркотике",
        "g": "Зелени рецепт",
        "t": "Т-рецепт"
      },
      "no-patient": {
        "title": "Пацијент није пронађен",
        "subtitle": "Нажалост, није пронађен ниједан пацијент за ову картицу. Молимо контактирајте особље за помоћ.",
        "try-again": "Покушајте поново",
        "back-home": "Назад на почетак",
        "title-v2": "Нема одговарајућих података",
        "subtitle-v2": "Нисмо могли да вас пронађемо. Молимо покушајте поново или питајте на пријему."
      },
      "done": {
        "title": "Хвала",
        "subtitle": "Сада можете да седнете. Ако имате питања, контактирајте особље.",
        "no-prescriptions-title": "Нема рецепата у спису",
        "no-prescriptions-subtitle": "Нисмо могли да пронађемо ниједан активан рецепт за вас. Ако сте га очекивали, обратите се особљу рецепције.",
        "error-title": "Дошло је до грешке",
        "error-subtitle": "Молимо контактирајте особље за даљу помоћ.",
        "auto-redirect": "Аутоматско преусмеравање за {{seconds}} секунди",
        "finish": "Назад на почетак"
      },
      "hub": {
        "title": "Ваши рецепти",
        "for-patient": "Рецепти за {{name}}",
        "loading": "Учитавање рецепата...",
        "error-title": "Грешка при учитавању",
        "fetch-error": "Није могуће учитати рецепте",
        "back-home": "Назад на почетак",
        "done": "Урађено",
        "order-button": "Рецепт за наруџбу",
        "existing-prescriptions": "Ваши тренутни рецепти",
        "no-prescriptions": "Нису пронађени активни рецепти."
      },
      "patient-lookup": {
        "title": "Пронађите пацијента",
        "subtitle": "Унесите своје име и датум рођења.",
        "last-name": "Презиме",
        "first-name": "Име",
        "date-of-birth": "Датум рођења",
        "lastname": "Презиме",
        "lastname-placeholder": "Ваше презиме",
        "firstname": "Име",
        "firstname-placeholder": "Ваше име",
        "dob": "Датум рођења",
        "search": "Претрага",
        "searching": "Претраживање...",
        "search-error": "Грешка претраге: {{message}}",
        "no-match": "Није пронађен ниједан пацијент. Проверите своје податке.",
        "error": "Грешка претраге. Покушајте поново.",
        "found": "Пронађен пацијент",
        "confirm": "Потврдите",
        "ambiguous": "Више поклапања",
        "ambiguous-hint-firstname": "Молимо такође унесите своје име да бисте прецизирали претрагу.",
        "ambiguous-hint-additional": "Молимо проверите своје податке или контактирајте особље.",
        "not-found": "Пацијент није пронађен",
        "not-found-hint": "Није пронађен ниједан пацијент са овим детаљима.",
        "not-found-action": "Покушајте поново"
      },
      "manual-identification": {
        "unverified": "Ваш идентитет није потврђен картицом здравственог осигурања. Ординација ће проверити ваше податке и захтев пре обраде."
      },
      "medication-selection": {
        "title": "Затражите рецепт",
        "subtitle": "Ординација разматра ваш захтев. Након одобрења, eRx је спреман у вашој апликацији e-prescription.",
        "back": "Назад",
        "submit": "Наставите са прегледом",
        "reason-title": "Зашто вам је потребан рецепт?",
        "reason-hint": "Помаже ординацији да процени ваш захтев.",
        "reason-validation": "Молимо изаберите разлог.",
        "reason-schmerzen": "Бол",
        "reason-entzuendung": "Упала",
        "reason-nachsorge": "После операције / процедура",
        "reason-allergie": "Алергија / реакција",
        "reason-chronisch": "Хронично стање",
        "reason-anderes": "Нешто друго",
        "medications-title": "Који лекови?",
        "request-hint": "Опишите шта вам је потребно или наведите претходни рецепт који желите да обновите.",
        "request-placeholder": "нпр. Ибупрофен 600 мг, исто као и прошли пут",
        "request-validation": "Молимо опишите који лек вам је потребан.",
        "history-title": "Претходни рецепти",
        "history-hint": "Додајте унос да унапред попуните свој захтев.",
        "history-loading": "Учитавање претходних рецепата...",
        "history-error": "Претходни рецепти нису могли да се учитају.",
        "history-add": "Додат",
        "history-added": "Додат",
        "history-date": "Последњи: {{date}}",
        "history-request-line": "Обновити: {{medicationName}}",
        "urgency-title": "Колико је хитно?",
        "urgency-hint": "Помаже ординацији да одреди приоритет.",
        "urgency-soon": "Хитно",
        "urgency-soon-meta": "Што је пре могуће",
        "urgency-tomorrow": "Ускоро",
        "urgency-tomorrow-meta": "У наредних неколико дана",
        "urgency-week": "Ове недеље",
        "urgency-week-meta": "Нема временског притиска",
        "lead": "Ординација ће проверити ваш захтев. Након одобрења е-рецепт ћете наћи у апликацији за е-рецепте или на здравственој картици.",
        "history-hint-v2": "Додирните ранији рецепт да бисте га преузели.",
        "history-retry": "Учитај поново"
      },
      "request-review": {
        "title": "Налог за ревизију",
        "subtitle": "Молимо прегледајте свој захтев за рецепт.",
        "request-label": "Тражени лекови",
        "selected-medications": "Изабрани лекови",
        "free-text-medications": "Додатни лекови",
        "freetext-label": "Остало",
        "quarterly-warning": "Ваша картица осигурања није очитана у овом кварталу. Ординација може да вас контактира.",
        "egk-warning": "Ваша картица осигурања није очитана у овом кварталу. Ординација може да вас контактира.",
        "submit": "Пошаљи",
        "submitting": "Слање...",
        "submit-error": "Није могао поднети захтев. Покушајте поново.",
        "back": "Назад",
        "reason-label": "Разлог",
        "urgency-label": "Хитност",
        "completion-email-choice": "Желим да добијем е-поруку када ординација обради мој захтев.",
        "completion-email-label": "Адреса е-поште",
        "completion-email-placeholder": "ime@primer.rs",
        "completion-email-hint": "Само за ову једнократну поруку. Адреса се не чува у матичним подацима.",
        "completion-email-invalid": "Унесите важећу адресу е-поште.",
        "egk-proof-required": "Захтеви за рецепт су могући само након успешног читања картице осигурања. Обратите се особљу.",
        "title-v2": "Провери захтев",
        "completion-email-hint-v2": "Адреса се користи само за ову једну поруку."
      },
      "confirmation": {
        "title": "Захтев је послат",
        "subtitle": "Ваш захтев за рецепт је успешно поднет.",
        "success-title": "Захтев је послат",
        "success-subtitle": "Ваш захтев за рецепт је успешно поднет.",
        "estimated-time": "Ваш рецепт ће бити спреман за приближно {{time}}.",
        "info": "Свој рецепт можете подићи у апотеци са картицом осигурања или апликацијом eRezept.",
        "auto-redirect": "Аутоматско преусмеравање за {{seconds}} секунди",
        "back-to-start": "Назад на почетак",
        "handling-label": "Handled by the practice",
        "next-steps": "Ординација ће проверити ваш захтев. Након одобрења е-рецепт можете подићи у апотеци са здравственом картицом или апликацијом за е-рецепте."
      },
      "phase": {
        "identify": "Пријава",
        "request": "Захтев",
        "review": "Провера"
      }
    },
    "check-in": {
      "flow-label": "Пријава",
      "has-appointment": {
        "eyebrow": "Именовање",
        "title": "Имате ли термин?",
        "subtitle": "Молимо изаберите опцију",
        "yes-label": "Да",
        "yes": "Да, имам термин",
        "yes-description": "Желим да се пријавим за свој термин.",
        "yes-hint": "Најбржи пут",
        "unsure-label": "Можда",
        "unsure": "Нисам сигуран",
        "unsure-description": "Проверићемо за вас.",
        "unsure-hint": "Тражићемо вас",
        "no-label": "бр",
        "no": "Не, без термина",
        "no-description": "Немам термин.",
        "no-hint": "Улазак"
      },
      "card-check": {
        "eyebrow": "Картица осигурања",
        "title": "Прочитај здравствену картицу",
        "subtitle": "Молимо уметните своју здравствену картицу у читач",
        "insert-title": "Убаците картицу здравственог осигурања у читач.",
        "insert-detail": "Аутоматски читамо ваше податке — не морате ништа друго да радите.",
        "other-ways": "Други начини",
        "no-card-hint": "Ако тренутно немате своју картицу код себе.",
        "pkv-hint": "Користите QR code са својом апликацијом за осигурање.",
        "loading": "Учитавање подешавања...",
        "no-terminal": "Нема конфигурисаног читача картица. Молимо контактирајте особље.",
        "checking": "Провера картица...",
        "insert-prompt": "Молимо уметните картицу...",
        "card-detected": "Картица откривена! Спремна за читање.",
        "read-card": "Прочитај картицу",
        "simulate-insert": "Симулирај картицу",
        "reading": "Читање картице...",
        "error": "Није могуће прочитати картицу. Молимо покушајте поново.",
        "read-error": "Грешка при читању података са картице. Молимо покушајте поново.",
        "settings-error": "Није могуће учитати подешавања. Молимо покушајте поново.",
        "no-card-prompt": "Немате картицу?",
        "no-card-action": "Ручна претрага",
        "connection-warning": "Проблеми са везом са читачем картица. сачекајте...",
        "pkv-prompt": "Приватно осигурање? Online Check-in",
        "pkv-instruction": "Скенирајте ово QR code помоћу апликације за приватно здравствено осигурање да бисте своје податке пренели дигитално.",
        "pkv-continue": "Наставите на ручну регистрацију",
        "unreadable-title": "Card detected, but no insurance data could be read.",
        "unreadable-body": "Please try again or go to the reception desk. You can also check in without your card.",
        "unreadable-help": "Покушајте поново или се пријавите без картице. Пријемно одељење ће вам радо помоћи.",
        "title-pkv": "Пријава преко апликације",
        "title-reading": "Ваша картица се очитава …",
        "title-unreadable": "Картицу није било могуће очитати",
        "title-no-terminal": "Пријава без картице",
        "no-terminal-body": "Читач картица тренутно није доступан. Пријавите се без картице или се обратите пријему.",
        "reading-detail": "Оставите картицу у читачу. Траје само тренутак.",
        "other-ways-title": "Друге могућности",
        "no-card-title": "Пријава без картице",
        "pkv-prompt-title": "Приватно осигурани?",
        "pkv-prompt-hint": "Пријава преко апликације вашег приватног здравственог осигурања",
        "pkv-close": "Ипак са картицом",
        "pkv-instruction-app": "Отворите апликацију свог приватног здравственог осигурања и скенирајте овај код. Ваши подаци тада стижу директно код нас."
      },
      "patient-selection": {
        "title": "Изаберите пацијента",
        "subtitle": "Пронађено више пацијената. Молимо изаберите себе.",
        "firstname-label": "Ваше име",
        "firstname-placeholder": "Унесите име...",
        "confirm-button": "Потврдите",
        "no-match": "Није пронађен одговарајући пацијент. Молимо идите на рецепцију за помоћ.",
        "still-ambiguous": "Остало је више поклапања. Молимо идите на рецепцију за помоћ.",
        "select-error": "Идентификација пацијента није успела. Покушајте поново.",
        "staff-assist": "Идите на рецепцију",
        "title-v2": "Кратко питање",
        "subtitle-v2": "Ради сигурности унесите своје име.",
        "no-match-v2": "Са тим именом вас нисмо пронашли. Проверите правопис или се обратите пријему.",
        "still-ambiguous-v2": "Још вас нисмо могли једнозначно пронаћи. Обратите се пријему.",
        "select-error-v2": "Нажалост није успело. Покушајте поново."
      },
      "card-checkin": {
        "title": "Потврди пријаву",
        "subtitle": "Ваши подаци су успешно прочитани.",
        "confirm": "Потврди пријаву"
      },
      "register-from-card": {
        "title": "Нова регистрација",
        "subtitle": "Још нисте у нашем систему. Желите ли да се региструјете?",
        "card-data": "Подаци о картици",
        "create": "Региструј се",
        "create-error": "Регистрација није успела. Покушајте поново или замолите особље за помоћ.",
        "staff-assist": "Позовите особље",
        "no-card-data-title": "Нема података о картици",
        "no-card-data": "Није могуће прочитати податке са ваше картице.",
        "insurance-verified": "Верификовано осигурање: {{insurer}}",
        "insurer-missing": "The card does not contain a cost-carrier identifier. Registration via the card is not possible. Please go to the reception desk.",
        "title-v2": "Ваши подаци са картице",
        "subtitle-v2": "Проверите своје податке. Ако нешто није тачно, додирните „Промени”.",
        "create-v2": "Потврди податке",
        "create-error-v2": "Пријава нажалост није успела. Покушајте поново или се обратите пријему.",
        "insurer-missing-v2": "На вашој картици недостаје податак о здравственом осигурању. Обратите се пријему.",
        "edit": "Промени",
        "name": "Име",
        "insurer": "Здравствено осигурање"
      },
      "patient-lookup": {
        "title": "Претрага пацијента",
        "subtitle": "Молимо унесите своје име или број осигурања.",
        "lastname": "Презиме",
        "lastname-placeholder": "Ваше презиме",
        "dob": "Датум рођења",
        "firstname": "Име",
        "firstname-placeholder": "Ваше име",
        "search": "Претрага",
        "searching": "Претраживање...",
        "search-placeholder": "Име или број осигурања...",
        "results-placeholder": "Резултати претраге ће се појавити овде",
        "found": "Пронађен пацијент!",
        "confirm-identity": "Молимо потврдите да сте приказани пацијент.",
        "confirm-button": "То сам ја",
        "ambiguous-firstname": "Пронађено је више пацијената. Унесите своје име.",
        "ambiguous-additional": "Пронађено је више пацијената. Молимо контактирајте особље.",
        "disambiguation-hint": "Ово нам помаже да вас јасно идентификујемо.",
        "not-found": "Није пронађен ниједан пацијент са овим детаљима.",
        "error": "Грешка претраге: {{message}}",
        "staff-assist": "Позовите особље",
        "not-found-prompt": "Није пронађено?",
        "register-new": "Региструј ново",
        "not-found-hint": "No patient could be found with these details.",
        "create-new": "Register new patient",
        "dob-placeholder": "DD.MM.YYYY",
        "dob-picker": "Choose date of birth in the calendar",
        "title-v2": "Пријава без картице",
        "subtitle-firstname": "Унесите и своје име.",
        "ambiguous-firstname-v2": "Више особа има ово презиме. Унесите и своје име.",
        "search-again": "Тражи поново",
        "found-v2": "Пронашли смо вас",
        "found-confirm": "Потврдите са „То сам ја”.",
        "not-found-title": "Нисмо вас пронашли",
        "not-found-check": "Проверите правопис и датум рођења. Пријем ће вам радо помоћи.",
        "not-found-reception": "Проверите правопис и датум рођења или се обратите пријему.",
        "ambiguous-additional-v2": "Нисмо вас могли једнозначно пронаћи. Обратите се пријему.",
        "error-v2": "Претрага тренутно није успела. Покушајте поново."
      },
      "checking-in": {
        "title": "Тренутак — пријављујемо вас.",
        "subtitle": "Додајемо вас у ред за третман и обавештавамо тим.",
        "step-insurance": "Осигурање проверено",
        "step-appointment": "Именовање потврђено",
        "step-waitlist": "Додавање на листу чекања",
        "error": "Пријављивање није успело. Покушајте поново.",
        "continue": "Ипак наставите",
        "title-v2": "Тренутак, молим",
        "loading": "Пријављујемо вас …",
        "subtitle-v2": "Уписујемо вас на листу чекања и обавештавамо тим.",
        "error-title": "Нажалост није успело",
        "error-v2": "Вашу пријаву није било могуће завршити.",
        "error-body": "Покушајте поново. Ако опет не успе, помоћи ће вам пријем."
      },
      "appointment-selection": {
        "title": "Изаберите термин",
        "subtitle": "Данас имате неколико састанака. Молимо изаберите једну.",
        "checking-in": "Пријављивање...",
        "time": "{{time}}",
        "error-v2": "Пријава за овај термин није успела. Покушајте поново или се обратите пријему."
      },
      "no-appointment": {
        "title": "Није пронађено именовање",
        "subtitle": "Нисмо могли да нађемо термин за вас данас. Молимо вас да резервишете редован термин.",
        "book-appointment": "Заказивање термина",
        "book-appointment-description": "Закажите нови термин преко редовног распореда.",
        "staff-assist": "Позовите особље",
        "staff-assist-description": "Треба ми помоћ.",
        "booking-disabled": "Appointment booking is currently unavailable",
        "booking-disabled-description": "Please contact the practice team to arrange an appointment.",
        "back-to-start": "Back to start",
        "subtitle-v2": "Данас за вас нисмо пронашли термин.",
        "book-v2": "Закажите нови термин",
        "book-v2-description": "Изаберите сада слободан термин.",
        "have-appointment": "Имам термин",
        "have-appointment-description": "Пријем ће вам радо помоћи.",
        "unavailable-title": "Термине заказујте на пријему",
        "subtitle-unavailable": "Данас за вас нисмо пронашли термин. Обратите се пријему."
      },
      "staff-assist": {
        "title": "Обавештено особље",
        "subtitle": "Члан особља ће вам ускоро помоћи.",
        "message": "Молимо сачекајте овде. Члан особља ће ускоро бити са вама.",
        "start-over": "Назад на почетак",
        "auto-redirect": "Враћање на почетак за {{seconds}} секунди..."
      },
      "eeb-prompt": {
        "title": "Провери осигурање",
        "title-failed": "Провера неуспешна",
        "subtitle": "Како желите да проверите своје осигурање?",
        "subtitle-failed": "Скенирајте QR код својом апликацијом осигурања за захтев провере.",
        "verify-card": "Провери електронски",
        "verify-card-description": "Пошаљите захтев свом осигуравачу.",
        "select-insurer": "Одабери осигуравача",
        "select-insurer-description": "Ручни одабир вашег осигуравача.",
        "skip": "Прескочи",
        "eyebrow-chip": "Алтернатива",
        "eyebrow": "Пријава · доказ о осигурању (eEB)",
        "recommended": "Препоручено",
        "qr-title": "Скенирајте помоћу апликације за осигурање",
        "qr-description": "Отворите апликацију за здравствено осигурање и скенирајте код — eEB се шаље директно нама.",
        "qr-address-label": "Пошаљи на",
        "title-app": "Потврда преко апликације",
        "subtitle-app": "Ваше осигурање нам може и директно послати потврду. Кад завршите, додирните „Даље”."
      },
      "quarterly-check": {
        "title": "Провера осигурања",
        "checking": "Проверавамо вашу тренутну проверу осигурања...",
        "error": "Провера није могла бити извршена.",
        "title-v2": "Ваше осигурање",
        "checking-v2": "Проверавамо ваше осигурање – тренутак, молим.",
        "error-body": "Ваша пријава је завршена. Осигурање ће са вама решити пријем."
      },
      "insurer-prefilled": {
        "title": "Ваше здравствено осигурање",
        "subtitle": "Молимо потврдите своје осигурање за овај квартал.",
        "your-insurance": "Ваше осигурање",
        "last-read": "Последња провера {{date}}",
        "quarterly-notice": "За потребе наплате потребан нам је тренутни доказ осигурања за овај квартал.",
        "confirm-button": "Да, ово је моје осигурање",
        "change-button": "Имам друго осигурање",
        "contact-title": "Захтевајте електронски доказ покрића",
        "contact-description": "Позовите своје осигурање и затражите електронски доказ о покрићу за:",
        "contact-patient": "Пацијент",
        "contact-kim-address": "KIM адреса ординације",
        "contact-phone": "Телефон",
        "question": "Да ли је ово ваше здравствено осигурање?",
        "quarterly-notice-v2": "Једном у тромесечју потребна нам је потврда вашег осигурања."
      },
      "insurer-search": {
        "title": "Изаберите здравствено осигурање",
        "subtitle": "Молимо претражите и изаберите своје обавезно здравствено осигурање.",
        "placeholder": "Претрага осигурања...",
        "hint": "Унесите најмање 2 знака за претрагу.",
        "no-results": "Нема пронађеног осигурања.",
        "no-results-hint": "Проверите правопис или покушајте другу претрагу.",
        "label": "Назив вашег здравственог осигурања",
        "search-error-v2": "Претрага тренутно није успела. Покушајте поново.",
        "app-alternative": "Радије преко апликације осигурања?"
      },
      "insurer-contact": {
        "title": "Захтевајте доказ о осигурању",
        "subtitle": "Молимо изаберите једну од следећих опција.",
        "or": "или",
        "option-eeb-title": "Захтевајте електронски",
        "option-eeb-description": "Ako postoji zakonski izuzetan slučaj, nakon vaše saglasnosti možete predati zahtev timu ordinacije.",
        "option-qr-title": "Скенирајте помоћу апликације",
        "option-qr-description": "Скенирајте QR code помоћу апликације за осигурање.",
        "option-call-title": "Позовите се",
        "option-call-description": "Позовите своје осигурање и затражите eEB за ову ординацију:",
        "phone": "Телефон",
        "phone-not-available": "Број телефона на вашој картици осигурања",
        "patient-name": "Пацијент",
        "practice-kim": "KIM адреса ординације",
        "help-notice": "Ако имате било каквих проблема, посетите рецепцију.",
        "submit-eeb-button": "Затражите одмах",
        "contacted-button": "Позвао сам",
        "contacted-button-countdown": "Време за ваш позив ({{seconds}}с)",
        "go-to-counter-button": "Идите на рецепцију",
        "qr-continue-button": "Скенирао сам",
        "qr-continue-button-countdown": "Време за скенирање ({{seconds}}с)",
        "title-v2": "Потврда вашег здравственог осигурања",
        "subtitle-v2": "Најједноставније је преко апликације вашег осигурања.",
        "subtitle-no-app": "Изаберите како нам ваше осигурање треба послати потврду.",
        "option-eeb-description-v2": "Ми ћемо за вас затражити потврду од осигурања. За то нам је потребна ваша сагласност.",
        "call-instruction": "Позовите своје осигурање и замолите да потврду пошаљу нашој ординацији.",
        "call-instruction-practice": "Позовите своје осигурање и замолите да потврду пошаљу ординацији {{practice}}.",
        "done-button": "Готово – даље",
        "done-button-countdown": "Готово – даље (још {{seconds}} с)"
      },
      "eeb-consent": {
        "title": "Сагласност",
        "subtitle": "Потребна нам је ваша сагласност за електронску проверу осигурања.",
        "insurance": "Ваше осигурање",
        "consent-title": "Сагласност за електронску проверу осигурања (eEB)",
        "consent-text": "Разумем да ће моје здравствено осигурање пренети моје податке о осигурању (нпр. име, датум рођења, број осигурања) путем безбедне KIM комуникационе услуге ординацији {{practiceName}} као доказ осигурања. Сагласан/сагласна сам са овим преносом. Знам да ову сагласност могу опозвати у било ком тренутку без утицаја на моје лечење.",
        "withdrawal-notice": "Можете опозвати ову сагласност у било ком тренутку.",
        "agree-button": "Слажем се",
        "decline-button": "Откажи",
        "treatment-notice": "Ваше лечење није под утицајем ове сагласности.",
        "load-failed": "The consent details could not be loaded. You can scan the QR code with your insurer app instead.",
        "not-available": "This request is not possible here right now. Please speak to reception.",
        "submit-failed": "Your consent could not be saved. Please try again or speak to reception.",
        "title-v2": "Потврда вашег здравственог осигурања",
        "summary": "Ваше осигурање нам директно шаље потврду. За то нам је потребна ваша сагласност.",
        "confirm-first": "Најпре потврдите изјаву."
      },
      "qr-code": {
        "title": "Скенирај апликацијом осигурања",
        "instruction-1": "Отворите своју апликацију осигурања и скенирајте овај QR код.",
        "instruction-2": "Ординација ће затим аутоматски примити вашу потврду осигурања.",
        "practice": "Ординација: {{name}}",
        "alternative-hint": "Алтернатива: Користите своју апликацију осигурања",
        "instruction-app": "Отворите апликацију свог здравственог осигурања и скенирајте овај код. Потврда тада стиже директно код нас.",
        "staff-line": "За тим ординације: {{address}}",
        "staff-line-practice": "За тим ординације: {{name}} · {{address}}",
        "alternative-app": "Потврду можете затражити и преко апликације свог осигурања: отворите апликацију и скенирајте овај код."
      },
      "register-basics": {
        "title": "Лични подаци",
        "subtitle": "Молимо унесите своје податке.",
        "family-name": "Презиме",
        "given-name": "Име",
        "dob": "Датум рођења",
        "gender": "Пол",
        "insurance-type": "Врста осигурања",
        "insurer-name": "Назив вашег осигурања",
        "insurer-name-placeholder": "нпр. Дебека, ДКВ, Алијанц...",
        "gender-required": "Изаберите једну могућност."
      },
      "register-insurer": {
        "title": "Здравствено осигурање",
        "subtitle": "Молимо изаберите своје здравствено осигурање.",
        "search-placeholder": "Претрага осигурања..."
      },
      "register-details": {
        "title": "Резиме",
        "subtitle": "Молимо прегледајте своје податке.",
        "create": "Заврши регистрацију",
        "missing-data": "Молимо попуните сва обавезна поља.",
        "create-error": "Регистрација није успела. Покушајте поново.",
        "policy-number": "Број политике (опционо)",
        "policy-number-placeholder": "Број ваше полице",
        "create-v2": "Заврши пријаву",
        "policy-number-hint": "Број ћете пронаћи на картици свог осигурања."
      },
      "diff-review": {
        "eyebrow-chip": "Преглед",
        "eyebrow": "Пријава · подаци о картици",
        "title": "Упоредба података",
        "subtitle": "Пронађене су разлике између података са ваше картице и наших записа.",
        "col-current": "Тренутни рекорд",
        "col-new": "Ново са картице",
        "new-badge": "ново",
        "field-fallback": "Поље",
        "note": "Ажурирани подаци нам помажу да исправно обрачунавамо и контактирамо вас у хитним случајевима.",
        "comparison-placeholder": "Упоредба ће бити приказана овде",
        "confirm": "Потврди промене",
        "apply-error": "Подаци се не могу применити. Покушајте поново.",
        "retry": "Покушајте поново",
        "skip": "Ипак наставите",
        "no-changes": "Нема пронађених промена",
        "title-v2": "Ваши подаци су се променили",
        "subtitle-v2": "На вашој картици су новији подаци. Да их преузмемо?",
        "confirm-v2": "Преузми и пријави",
        "keep": "Пријава без промене",
        "col-current-v2": "Досад",
        "col-new-v2": "Ново са картице",
        "value-yes": "Да",
        "value-no": "Не"
      },
      "insurance-selection": {
        "title": "Врста осигурања",
        "subtitle": "Молимо изаберите своју врсту осигурања.",
        "gkv": "Законски осигуран",
        "gkv-description": "Члан обавезног здравственог осигурања.",
        "pkv": "Приватно или самоплаћање",
        "pkv-description": "Приватно осигуран или самоплаћање.",
        "pkv-description-v2": "Приватно здравствено осигурање или плаћате сами."
      },
      "eeb-request": {
        "title": "Zahtev je zabeležen",
        "subtitle": "Možete da završite prijavu. Odgovor od {{insurer}} stiže u ordinaciju kasnije.",
        "verifying": "Vaš zahtev je prihvaćen na neposrednu obradu.",
        "success": "Vaš zahtev je bezbedno predat timu ordinacije.",
        "error": "Potvrda zahteva nije dostupna.",
        "try-alternative": "Алтернативна метода",
        "kim-load-error": "KIM адреса ординације није могла да се учита.",
        "kim-label": "Ординација · KIM",
        "non-blocking-note": "Ovo još ne potvrđuje prijem od strane vašeg zdravstvenog osiguranja ni vaš status osiguranja.",
        "auto-continue": "Аутоматски наставак за {{seconds}} секунди.",
        "unavailable-title": "Нажалост није успело",
        "unavailable-v2": "Ваш захтев према здравственом осигурању није било могуће забележити.",
        "unavailable-body": "Потврду можете затражити преко апликације осигурања или то решити на пријему.",
        "use-app": "Преко апликације",
        "at-reception": "Решити на пријему"
      },
      "self-pay": {
        "title": "Самоплаћање",
        "subtitle": "Бићете третирани као пацијент са самоплаћањем.",
        "info": "Молимо имајте на уму да ћете бити одговорни за трошкове лечења.",
        "confirm": "Разумем",
        "title-v2": "Плаћате сами",
        "subtitle-v2": "Лечење плаћате сами.",
        "insured-after-all": "Ипак сам осигуран"
      },
      "done": {
        "title": "Готово!",
        "subtitle": "Ваша пријава је завршена.",
        "finish": "Заврши",
        "done-label": "Готово",
        "error-label": "Обавештење",
        "eyebrow": "Пријава · завршена",
        "queue-label": "Чекаоница",
        "queue-title": "Молим вас седите",
        "queue-meta": "Позваћемо вас лично.",
        "success-title": "Пријава успешна!",
        "success-subtitle": "Молимо седните у чекаоницу. Бићете позвани.",
        "auto-redirect": "Ускоро ћете бити преусмерени на почетну страницу...",
        "auto-redirect-countdown": "Враћање на почетак за {{seconds}} секунди...",
        "card-expired-title": "Картица истекла",
        "card-expired-subtitle": "Ваша здравствена картица је истекла.",
        "card-expired-info": "Молимо контактирајте особље за помоћ.",
        "back-to-start": "Назад на почетак",
        "anamnesis-title": "Попуните образац историје болести",
        "anamnesis-description": "Скенирајте QR code да бисте на паметном телефону на погодан начин попунили образац за историју болести.",
        "title-confirm": "Thank you!",
        "subtitle-confirm": "You have confirmed your details. Your check-in is complete — please take a seat in the waiting room.",
        "title-saved": "Thank you!",
        "subtitle-saved": "Your changes have been processed. Reception will get in touch if anything is open. Please take a seat in the waiting room.",
        "title-skip": "Skipped",
        "subtitle-skip": "No problem — your check-in is complete. You can tell reception about changes at any time.",
        "title-v2": "Пријављени сте",
        "card-expired-info-v2": "Обратите се пријему."
      },
      "patient-info": {
        "loading": "Loading your contact details …",
        "review": {
          "title": "Review contact details",
          "intro": "Are these details still correct? The review is voluntary — your check-in is already complete.",
          "no-contacts": "No telephone numbers or email addresses are on file.",
          "all-correct": "Everything is correct",
          "skip": "Skip",
          "primary": "Primary",
          "protected": "Reception will review any change to this contact.",
          "reveal": "Show",
          "hide": "Hide",
          "type": {
            "MOBILEPRIV": "Mobile (private)",
            "PHONEPRIV": "Phone (private)",
            "MOBILEJOB": "Mobile (work)",
            "PHONEJOB": "Phone (work)",
            "EMAILPRIV": "Email (private)",
            "EMAILJOB": "Email (work)"
          },
          "save": "Save",
          "save-failed": "Could not save — please speak to reception.",
          "delete": "Delete",
          "undo": "Undo",
          "invalid": "Please check the format.",
          "add": "Add",
          "add-title": "Add a contact",
          "add-type": "Type",
          "add-value": "Enter a value",
          "hausarzt": "Family doctor / GP",
          "hausarzt-placeholder": "Enter a name or practice",
          "hausarzt-reception": "Reception will review any change to this information.",
          "hausarzt-invalid": "Enter no more than 120 characters.",
          "category": {
            "phone": "Phone",
            "email": "Email",
            "hausarzt": "Family doctor"
          },
          "category-empty": "Not on file",
          "primary-tag": "Main contact",
          "protected-chip": "Protected — reception reviews",
          "chip-direct": "Changes: saved directly",
          "chip-reception": "Changes: reception reviews",
          "chip-staged_one": "{{count}} change pending",
          "chip-staged_other": "{{count}} changes pending",
          "chip-will-add": "Will be added",
          "expand-phone_one": "Show {{count}} more number",
          "expand-phone_other": "Show {{count}} more numbers",
          "expand-email_one": "Show {{count}} more address",
          "expand-email_other": "Show {{count}} more addresses",
          "collapse-phone_one": "Hide additional number",
          "collapse-phone_other": "Hide additional numbers",
          "collapse-email_one": "Hide additional address",
          "collapse-email_other": "Hide additional addresses",
          "change": "Change",
          "close": "Close",
          "staged-removal": "Will be removed — value hidden",
          "stage-add": "Add to list",
          "add-more-phone": "Add another number",
          "add-more-email": "Add another address",
          "invalid-phone": "Please enter a valid phone number.",
          "invalid-email": "Please enter a valid email address.",
          "hausarzt-previous": "previously: {{value}}",
          "hausarzt-counter": "{{count}} / 120",
          "balance-total_one": "{{count}} change",
          "balance-total_other": "{{count}} changes",
          "balance-direct": "{{count}} saved directly",
          "balance-reception": "{{count}} reviewed by reception",
          "proposal-open": "Suggest a new address",
          "proposal-placeholder": "Your suggestion",
          "proposal-discard": "Discard",
          "proposal-hint": "Your suggestion goes to reception — the address is not changed immediately.",
          "title-v2": "Проверите своје податке",
          "balance-prefix": "При чувању:",
          "balance-direct-v2": "Одмах сачувано: {{count}}",
          "balance-reception-v2": "Проверава пријем: {{count}}",
          "chip-reception-v2": "Промене проверава наш пријем",
          "chip-changed": "Промењено: {{count}}",
          "remove": "Уклони",
          "example-email": "нпр. ime@primer.rs",
          "example-phone": "нпр. 064 123 4567",
          "intro-v2": "Ваша пријава је завршена. Да ли су ови подаци још тачни? Провера је добровољна.",
          "auto-hide": "Приказане вредности се после кратког времена поново скривају."
        },
        "result": {
          "title": "Result",
          "continue": "Continue",
          "outcome": {
            "updated": "Updated",
            "satisfied": "Was already up to date",
            "task-created": "Sent to reception",
            "not-saved": "Not saved yet",
            "pending-retry": "Not saved yet"
          },
          "retry": "Try again",
          "removed": "Was removed",
          "cleared": "Was cleared",
          "task-note": "Nothing was overwritten — reception will get in touch if needed.",
          "not-saved-note": "Nothing was overwritten. Please speak to reception.",
          "banner-unfinished": "One detail has not been saved yet. You can try again directly on that row.",
          "banner-done": "Your details have been processed.",
          "footer": "All other details remain unchanged.",
          "task-note-v2": "Овај податак смо проследили пријему.",
          "banner-done-v2": "Хвала! Примили смо ваше податке.",
          "footer-v2": "Сви остали подаци остају непромењени."
        },
        "expiry": {
          "notice": "For data protection reasons the review ends in 2 minutes. Your check-in stays complete.",
          "title": "The review has expired",
          "body": "For data protection reasons all displayed and entered values were deleted. Your check-in is still complete — you do not need to repeat anything. You can tell reception about changes at any time.",
          "continue": "To the summary",
          "body-v2": "Из разлога заштите података затворили смо приказ. Ваша пријава је ипак завршена. Промене можете у сваком тренутку јавити пријему."
        }
      },
      "progress": {
        "identify": "Пријава",
        "insurance": "Осигурање",
        "done": "Готово"
      },
      "dob-format-hint": "На пример 01.10.1980",
      "dob-required": "Унесите свој датум рођења.",
      "insurance-label": {
        "GKV": "Обавезно осигурање",
        "PKV": "Приватно осигурање",
        "SELFPAY": "Самоплатилац"
      }
    },
    "emergency": {
      "title": "Акутна хитна ситуација!",
      "label": "Хитно",
      "subtitle": "Овај аларм се чује само локално и није позвао помоћ. У акутним или потенцијално животно угрожавајућим случајевима позовите 112.",
      "call-emergency": "Позовите хитне службе (112)",
      "stop-sound": "Зауставите звук",
      "play-sound": "Пусти звук",
      "back-to-start": "Назад на почетак",
      "headline": "Одмах се обратите особљу на пријему. У случају опасности по живот позовите 112."
    },
    "help-reception": "Помоћ за пријем",
    "help-reception-toast": "Молимо контактирајте рецепцију. Радо ћемо помоћи.",
    "language-entry": {
      "title": "Изаберите језик"
    },
    "loading": "Учитавање…",
    "step-progress-label": "Напредак",
    "step-progress-phase": "Одељак {{current}} од {{total}}: {{phase}}",
    "step-progress-substep": "Део {{current}} од {{total}}",
    "step-progress-complete": "Завршено",
    "identification": {
      "title": "Ко сте ви?",
      "lead": "Најбрже иде са здравственом картицом. Можете и да тражите по имену.",
      "lead-card-only": "Молимо убаците здравствену картицу у читач картица.",
      "mode-label": "Како желите да се пријавите?",
      "mode-card": "Картицом",
      "mode-search": "Тражи по имену",
      "mode-create": "Нови пацијент",
      "card": {
        "loading": "Припрема читача картица …",
        "checking": "Провера читача картица …",
        "insert-title": "Молимо убаците здравствену картицу у читач картица.",
        "insert-detail": "Ваше податке читамо аутоматски.",
        "detected": "Картица препозната",
        "read": "Прочитај картицу",
        "reading": "Картица се чита …",
        "reading-hint": "Молимо оставите картицу у читачу.",
        "no-terminal-title": "Читач картица није доступан",
        "help-with-search": "Молимо потражите по имену или питајте на пријему.",
        "help-reception": "Молимо питајте на пријему – радо ћемо помоћи.",
        "unreadable-title": "Картица препозната, али није читљива",
        "error-title": "Картицу није било могуће прочитати",
        "not-unique": "Нисмо могли једнозначно да вас повежемо са овом картицом. Молимо потражите по имену или питајте на пријему.",
        "no-match": "За ову картицу нисмо пронашли податке. Молимо потражите по имену или питајте на пријему.",
        "without-card": "Настави без картице"
      },
      "lookup": {
        "lead": "Молимо унесите презиме и датум рођења.",
        "first-name": "Име",
        "last-name": "Презиме",
        "dob": "Датум рођења",
        "dob-hint": "Формат: ДД.ММ.ГГГГ",
        "search": "Тражи",
        "confirm": "Да, то сам ја",
        "found-title": "Пронашли смо вас",
        "found-body": "Молимо потврдите да се ради о вама.",
        "first-name-needed-title": "Молимо допишите своје име",
        "first-name-needed-body": "Да бисмо вас једнозначно пронашли. Затим додирните „Тражи”.",
        "ambiguous-title": "Нисмо могли једнозначно да вас пронађемо",
        "ambiguous-body": "Молимо питајте на пријему – радо ћемо помоћи.",
        "not-found-title": "Нема одговарајућих података",
        "not-found-body": "Молимо проверите унете податке.",
        "error-title": "Претрага тренутно није могућа",
        "error-body": "Молимо покушајте поново или питајте на пријему."
      },
      "create": {
        "insurance-question": "Како сте осигурани?",
        "insurance-required": "Молимо изаберите како сте осигурани.",
        "error-title": "Ваше податке није било могуће сачувати",
        "error-body": "Молимо покушајте поново или питајте на пријему."
      }
    }
  },
  "onboarding": {
    "prepare": {
      "title": "Прво откључај",
      "subtitle": "FrontDesk+ мора бити активиран у софтверу медицинске праксе.",
      "step1": "Наручите у SolStore (или ваш Doc-Cirrus партнер наручује за вас).",
      "step2": "Након активације, активирајте у inSuite под „inSuite Sols“ (администраторска права).",
      "step3": "Отворите администрацију Bridge → „Додај уређај“.",
      "cta": "Све готово - идите даље"
    },
    "welcome": {
      "title": "Додајте овај уређај пракси",
      "scan": "Сликајте код",
      "prepare-link": "Нема кода у inSuite?",
      "language": "Језик"
    },
    "scan": {
      "requesting": "Захтева се приступ камери…",
      "scanning": "Усмерите камеру на код",
      "paste": "Уместо тога залепите",
      "manual-title": "Повежите се ручно",
      "manual-description": "Ако КР код није доступан, узмите податке о вези од Bridge администрације.",
      "address-label": "Bridge адреса",
      "address-placeholder": "хттпс://…/_рест_",
      "soltoken-label": "SOLTOKEN",
      "soltoken-placeholder": "Уметните SOLTOKEN",
      "manual-submit": "Преузми везу",
      "error-title": "Код није препознат",
      "camera-denied-title": "Приступ камери је одбијен",
      "camera-denied-hint": "Дозволите приступ камери у подешавањима и покушајте поново.",
      "retry": "Покушајте поново"
    },
    "preflight": {
      "title": "Биће постављено",
      "all-green": "Сви тестови су прошли",
      "practice": "Вежбајте",
      "device-name": "Назив уређаја",
      "device-name-placeholder": "нпр. Б. Пријем 1",
      "card-reader": "Читач картица",
      "pin": "Нови тајни број",
      "pin-placeholder": "Четвороцифрени ПИН",
      "finish": "Заврши",
      "recheck": "Проверите поново",
      "diagnosis": "ИД дијагнозе",
      "checklist-error": "Bridge је одбио везу или није доступан. Проверите SOLTOKEN и адресу Bridge-а.",
      "checklist-retry": "Провери поново",
      "edit-token": "Промени SOLTOKEN",
      "rescan": "Поново скенирајте код"
    },
    "persisting": "Чување подешавања …",
    "success": {
      "title": "Уређај је додат",
      "detail": "Уређај се управо појавио на рачунару за вежбање.",
      "starting": "Режим за пацијента почиње…"
    },
    "checklist": {
      "general_api_unavailable": {
        "label": "Повезивање са софтвером за вежбање",
        "fix": "Bridge Проверите везу и адресу сервера."
      },
      "missing_insuite_url": {
        "label": "inSuite адреса",
        "fix": "Поново скенирајте КР код - адреса недостаје."
      },
      "missing_server_token": {
        "label": "Серверски токен",
        "fix": "Поново скенирајте КР код - токен недостаје."
      },
      "missing_gateway_session": {
        "label": "Gateway сесија",
        "fix": "Пријавите се поново — сесија недостаје."
      },
      "missing_gateway_enrollment": {
        "label": "Регистрација уређаја",
        "fix": "Региструјте уређај на Gateway."
      },
      "gateway_not_ready": {
        "label": "Gateway спремност",
        "fix": "Сачекајте да Gateway заврши подешавање."
      },
      "token_verification_failed": {
        "label": "Провера токена",
        "fix": "Проверите токен сервера или Bridge везу."
      },
      "session_expired": {
        "label": "састанак",
        "fix": "Сесија је истекла - пријавите се поново."
      },
      "device_revoked": {
        "label": "Статус уређаја",
        "fix": "Овај уређај је блокиран. Обратите се ординацији."
      },
      "missing_practice_name": {
        "label": "Назив вежбе",
        "fix": "Назив медицинске ординације није могао да се учита (inSuite)."
      },
      "missing_device_name": {
        "label": "Назив уређаја",
        "fix": "Унесите назив уређаја."
      },
      "telematik_unavailable": {
        "label": "Телематска инфраструктура",
        "fix": "Опционо — провера картице остаје могућа чим ТИ буде доступан."
      },
      "selected_card_reader_unavailable": {
        "label": "Читач картица",
        "fix": "Опционо — изаберите или повежите читач картица."
      },
      "medical_card_unavailable": {
        "label": "SMC-B / HBA",
        "fix": "Опционо — убаците акредитивну картицу медицинске праксе (SMC-B)."
      }
    },
    "token": {
      "title": "Унесите SOLTOKEN",
      "description": "Из безбедносних разлога QR код не садржи SOLTOKEN. Копирајте га у inSuite-у под „Sol-Aktivierung” (FrontDesk+) и налепите га овде.",
      "submit": "Настави",
      "rescan": "Поново скенирајте код"
    }
  }
}
